export const getBookingEndpoint = '/berths/booking' as const
